import { handleActions } from 'redux-actions';
import { PaymentMethodType } from '@airwallex/airwallex-payment-elements';

export const AVAILABLE_PAYMENT_METHODS_SET = 'CHECKOUT/AVAILABLE_PAYMENT_METHODS/SET';

export type AvailablePaymentMethods = {
  name: PaymentMethodType;
  transaction_currencies: string[];
  transaction_mode: 'oneoff' | 'recurring';
}[];

export const reducer = handleActions(
  {
    [AVAILABLE_PAYMENT_METHODS_SET]: (_, action) => action.payload,
  },
  [] as AvailablePaymentMethods,
);

export default reducer;
